import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import AdminPageContainer from '@/components/AdminPageContainer';
import SEOMetrics from '@/components/SEO/SEOMetrics';
import TrafficChart from '@/components/SEO/TrafficChart';
import { FaSearch, FaLink, FaMobileAlt } from 'react-icons/fa';

const SEOKeywords = () => {
  const [keywords] = useState([
    { keyword: 'serralheria industrial', position: 3, change: 2, volume: 880, url: '/servicos/serralheria-industrial' },
    { keyword: 'estruturas metálicas', position: 5, change: -1, volume: 720, url: '/servicos/estruturas-metalicas' },
    { keyword: 'esquadrias de alumínio', position: 8, change: 0, volume: 480, url: '/produtos/esquadrias' },
    { keyword: 'coberturas metálicas', position: 12, change: 3, volume: 320, url: '/servicos/coberturas' },
    { keyword: 'portões automáticos', position: 15, change: 1, volume: 210, url: '/produtos/portoes' },
  ]);

  return (
    <div className="mt-8">
      <h2 className="text-lg font-medium text-gray-900">Palavras-chave</h2>
      <div className="mt-4 overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
        <table className="min-w-full divide-y divide-gray-300">
          <thead className="bg-gray-50">
            <tr>
              <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                Palavra-chave
              </th>
              <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                Posição
              </th>
              <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                Variação
              </th>
              <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                Volume/mês
              </th>
              <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                <span className="sr-only">Ações</span>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {keywords.map((item, index) => (
              <tr key={index}>
                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                  <div className="flex items-center">
                    <FaSearch className="mr-2 h-4 w-4 text-gray-400" />
                    {item.keyword}
                  </div>
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                  <span className="inline-flex items-center rounded-full bg-indigo-100 px-2.5 py-0.5 text-xs font-medium text-indigo-800">
                    #{item.position}
                  </span>
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm">
                  <span className={`inline-flex items-center ${item.change > 0 ? 'text-green-600' : item.change < 0 ? 'text-red-600' : 'text-gray-500'}`}>
                    {item.change > 0 ? (
                      <>
                        <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M12 7a1 1 0 01-1.707-.707L10 6.586 7.707 8.879a1 1 0 11-1.414-1.414l3-3a1 1 0 011.414 0l3 3A1 1 0 0112 7z" clipRule="evenodd" />
                        </svg>
                        {item.change}
                      </>
                    ) : item.change < 0 ? (
                      <>
                        <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M12 13a1 1 0 01-.707-.293L10 11.414l-1.293 1.293a1 1 0 01-1.414-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-.707 1.707z" clipRule="evenodd" />
                        </svg>
                        {Math.abs(item.change)}
                      </>
                    ) : (
                      '—'
                    )}
                  </span>
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{item.volume}</td>
                <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                  <a href={item.url} target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-900">
                    Ver página
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const SEOPage = () => {
  return (
    <AdminPageContainer>
      <Helmet>
        <title>SEO - Painel Administrativo</title>
      </Helmet>
      
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Otimização de SEO</h1>
            <p className="mt-1 text-sm text-gray-500">
              Acompanhe e melhore o desempenho do seu site nos mecanismos de busca
            </p>
          </div>
        </div>

        <SEOMetrics />
        <TrafficChart />
        <SEOKeywords />

        <div className="mt-8 grid gap-6 md:grid-cols-2">
          <div className="rounded-lg bg-white p-6 shadow">
            <h3 className="text-lg font-medium text-gray-900">Otimização para Mobile</h3>
            <div className="mt-4 flex items-center space-x-4">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
                <FaMobileAlt className="h-6 w-6 text-green-600" />
              </div>
              <div>
                <p className="text-sm text-gray-500">Status</p>
                <p className="text-lg font-medium text-gray-900">Otimizado</p>
              </div>
            </div>
            <div className="mt-4">
              <div className="h-2 overflow-hidden rounded-full bg-gray-200">
                <div className="h-2 w-4/5 rounded-full bg-green-500"></div>
              </div>
              <p className="mt-2 text-xs text-gray-500">Desempenho: 85/100</p>
            </div>
          </div>

          <div className="rounded-lg bg-white p-6 shadow">
            <h3 className="text-lg font-medium text-gray-900">Links quebrados</h3>
            <div className="mt-4">
              <div className="flex items-center space-x-4">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
                  <FaLink className="h-6 w-6 text-red-600" />
                </div>
                <div>
                  <p className="text-sm text-gray-500">Total de erros</p>
                  <p className="text-lg font-medium text-gray-900">3 links quebrados</p>
                </div>
              </div>
              <div className="mt-4">
                <a
                  href="#"
                  className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-500"
                >
                  Ver detalhes
                  <svg
                    className="ml-1 h-4 w-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminPageContainer>
  );
};

export default SEOPage;
